import api from '../../api'

var request_interceptor = null
var response_interceptor = null

function remove_interceptors() {
    remove_request_interceptor()
    remove_response_interceptor()
}

function remove_request_interceptor() {
    if (request_interceptor !== null) {
        api.interceptors.response.eject(request_interceptor)
        request_interceptor = null
    }
}

function remove_response_interceptor() {
    if (response_interceptor !== null) {
        api.interceptors.response.eject(response_interceptor)
        response_interceptor = null
    }
}

function bind_interceptors(dispatch, state) {
    remove_interceptors()
    request_interceptor = api.interceptors.request.use(
        (config) => {
            if (state.token != null) {
                config.headers.Authorization = `Bearer ${state.token}`
            }
            return config
        },
        (err) => {
            return Promise.reject(err)
        }
    )
    response_interceptor = api.interceptors.response.use(
        (response) => {
            return response
        },
        async (error) => {
            if (error.response.config.isResend) {
                return Promise.reject(error)
            }

            if (!error.response || error.response.status !== 401) {
                return Promise.reject(error)
            }

            try {
                await dispatch('refresh_auth')
                error.response.config.Authorization = `Bearer ${state.token}`
                error.response.config.isResend = true
                return api(error.response.config)
            } catch (error) {
                return Promise.reject(error)
            }
        }
    )
}

const actions = {
    initialize: async function ({ state, dispatch }) {
        if (state.token) {
            try {
                if (new Date(state.expiry) <= new Date().addMinutes(5)) {
                    await dispatch('refresh_auth')
                } else {
                    bind_interceptors(dispatch, state)
                }
            } catch (error) {
                console.error(error)
            }
        }
    },
    login: async function (
        { commit, dispatch, getters, state },
        { remember, username, password, preventRedirect }
    ) {
        if (!getters.is_authenticated) {
            var response = await api.auth.login(username, password)

            var payload = {
                ...response,
                remember: remember
            }

            commit('SET_PREVENT_REDIRECT', preventRedirect)
            commit('SET_TOKEN', payload)
            bind_interceptors(dispatch, state)
        }
    },
    logout: async function ({ state, commit, getters }) {
        if (getters.is_authenticated) {
            try {
                remove_response_interceptor()
                await api.auth.logout(state.current_user.id)
            } catch (error) {
                console.error(error)
            } finally {
                remove_interceptors()
                commit('CLEAR')
            }
        }
    },
    register: async function (
        { commit, dispatch, getters, state },
        { firstName, email, password }
    ) {
        if (!getters.is_authenticated) {
            var response = await api.auth.register(firstName, email, password)

            var payload = {
                ...response,
                remember: false
            }
            commit('SET_TOKEN', payload)
            bind_interceptors(dispatch, state)
        }
    },
    create: async function ({ _ }, { firstName, lastName, email, roles }) {
        return await api.auth.create(firstName, lastName, email, roles)
    },
    refresh_auth: async function ({ state, getters, commit, dispatch }) {
        if (state.token) {
            try {
                remove_response_interceptor()
                var response = await api.auth.refresh(state.token)
                var payload = {
                    ...response,
                    remember: getters.remember_user
                }
                commit('SET_TOKEN', payload)
                bind_interceptors(dispatch, state)
            } catch (error) {
                dispatch('logout')
                throw error
            }
        } else {
            dispatch('logout')
        }
    },
    fetchEdition: async function ({ commit }) {
        var edition = await api.editions.fetchEdition()
        commit('SET_EDITION', edition)
    }
}

export default actions
